import { render, staticRenderFns } from "./QuestionThird.vue?vue&type=template&id=15ce80d3"
import script from "./QuestionThird.vue?vue&type=script&lang=js"
export * from "./QuestionThird.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports